import { useLocation } from 'react-router';
import { type Maybe } from '../../../../api/types';
import NotFoundResult from '../../../../components/results/NotFoundResult';
import { type StandardApplicationState } from '../Journey/JourneyController';
import { type State } from '../Journey/reducer';
import Content from './Content';

const ThankYouPage = () => {
    const state = useLocation().state as Maybe<State<StandardApplicationState>>;

    if (!state) {
        return <NotFoundResult />;
    }

    return <Content state={state} />;
};

export default ThankYouPage;
